// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"1e2f57c3e6f52bcd1362","691":"934320a8c852709af00a"}[chunkId] + ".js";
};